// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"79f7553e","186":"e3faa003","225":"efa2f15f","344":"2309bcb0","372":"f59deeac","377":"cba665cc","738":"c170fd59","841":"29c5e0a2","856":"32abe7b4"}[chunkId] + ".chunk.js";
};